// import {} from '@chakra-ui/ana';
import { SystemStyleObject } from '@chakra-ui/styled-system';

const baseStyleContent: SystemStyleObject = {
  border: 'none',
  boxShadow: '0px 3px 20px #0000001A',
  borderRadius: '4px',
  overflow: 'hidden',
  width: 'inherit',
  _focus: {
    boxShadow: '0px 3px 20px #0000001A',
  },
};
const baseStyleBody: SystemStyleObject = {
  padding: '0',
};

const baseStyle = {
  content: baseStyleContent,
  body: baseStyleBody,
};

export const Popover = {
  parts: ['content', 'body'],
  baseStyle,
};
